export default __webpack_public_path__ + "static/media/browser-edge.fe09323c.svg";